import { render } from "./InjuryAffirmBill_XY.vue?vue&type=template&id=d0026b56&scoped=true"
import script from "./InjuryAffirmBill_XY.vue?vue&type=script&lang=js"
export * from "./InjuryAffirmBill_XY.vue?vue&type=script&lang=js"

import "./InjuryAffirmBill_XY.vue?vue&type=style&index=0&id=d0026b56&lang=scss&scoped=true"
import "./InjuryAffirmBill_XY.vue?vue&type=style&index=1&id=d0026b56&lang=scss&scoped=true"
import "./InjuryAffirmBill_XY.vue?vue&type=style&index=2&id=d0026b56&scoped=true&lang=css"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0026b56"]])

export default __exports__